import { render, staticRenderFns } from "./logisticVariant.vue?vue&type=template&id=3515d63a&scoped=true&"
import script from "./logisticVariant.vue?vue&type=script&lang=js&"
export * from "./logisticVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515d63a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3515d63a')) {
      api.createRecord('3515d63a', component.options)
    } else {
      api.reload('3515d63a', component.options)
    }
    module.hot.accept("./logisticVariant.vue?vue&type=template&id=3515d63a&scoped=true&", function () {
      api.rerender('3515d63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/logisticVariant/logisticVariant/logisticVariant.vue"
export default component.exports